var map = {
	"./kushner-attias.jpg": 7,
	"./kushner-attias.png": 8,
	"./kushner-davos.png": 9,
	"./kushner-egypt.png": 10,
	"./kushner-egypt.webp": 11,
	"./kushner-fii.jpg": 12,
	"./kushner-fii.png": 13,
	"./kushner-forbes.jpg": 14,
	"./kushner-forbes.png": 15,
	"./kushner-inauguration.jpg": 16,
	"./kushner-inauguration.png": 17,
	"./kushner-jerusalem.webp": 18,
	"./kushner-witkoff.jpg": 19,
	"./kushner-witkoff.png": 20,
	"./phoenix-report.png": 21
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6;